import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { EXPORT_FORMATS, exportFormatLabel, type ExportFormat } from "@/lib/export-format";

interface ExportFormatMenuItemsProps {
  disabled?: boolean;
  onSelect: (format: ExportFormat) => void;
}

export function ExportFormatMenuItems({
  disabled = false,
  onSelect,
}: ExportFormatMenuItemsProps) {
  return EXPORT_FORMATS.map((format) => {
    const label = exportFormatLabel(format);
    return (
      <DropdownMenuItem
        key={format}
        aria-label={`Export as ${label}`}
        disabled={disabled}
        onSelect={() => onSelect(format)}
      >
        {label}
      </DropdownMenuItem>
    );
  });
}
